import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { NAV_PATHS, Widgets } from '@modules/common/constants';
import { isEmptyWhereClause } from '@modules/common/utils';
import { VisualisationType } from '@modules/quantify/store/types';
import { getQuantifyAnalysisURL } from '@modules/quantify/utils';
import { compressToEncodedURIComponent } from 'lz-string';
import { FieldNames } from 'v2/core/entities/fields';
import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

interface getUseInQuantifyV2LinkOptions {
  widget: Widgets;
  whereClause?: WhereClause;
  duration?: DateTimeRange;
  shouldShowCooccurringDataPoints?: boolean;
}

export function getUseInQuantifyV2Link({
  widget,
  whereClause,
  duration,
  shouldShowCooccurringDataPoints,
}: getUseInQuantifyV2LinkOptions) {
  const isReasonWidget = widget === Widgets.Reason;

  const getGroupByValue = () => {
    if (isReasonWidget) {
      return FieldNames.Reason;
    }
    if (widget === Widgets.Source) {
      return FieldNames.Source;
    }
    if (widget === Widgets.ReviewSentiment) {
      return FieldNames.ReviewSentiment;
    }

    return FieldNames.Entity;
  };

  const getActiveVisualisationType = () => {
    switch (widget) {
      case Widgets.Reason:
        return VisualisationType.BAR;
      case Widgets.Source:
      case Widgets.ReviewSentiment:
        return VisualisationType.PIE;
      case Widgets.TrackedKeywordCategory:
        return VisualisationType.BAR;
      default:
        return undefined;
    }
  };

  const getShouldShowCategories = () => {
    return widget === Widgets.TrackedKeywordCategory;
  };

  const getWhereClause = () => {
    const where =
      whereClause && isEmptyWhereClause(whereClause) ? undefined : whereClause;

    if (where) {
      return where;
    }

    return where || EmptyWhereClause;
  };

  const search = compressToEncodedURIComponent(
    getQuantifyAnalysisURL({
      groupByValue: getGroupByValue(),
      shouldShowCategories: getShouldShowCategories(),
      activeVisualisationType: getActiveVisualisationType(),
      duration: duration as DateTimeRange,
      whereClauseConfig: {
        whereClause: getWhereClause() ?? null,
      },
      shouldShowCooccurringDataPoints: shouldShowCooccurringDataPoints,
    }),
  );

  return {
    pathname: `/${NAV_PATHS.QUANTIFY}`,
    search,
  };
}
